import { render, staticRenderFns } from "./SearchERP.vue?vue&type=template&id=1c12b381&scoped=true"
import script from "./SearchERP.vue?vue&type=script&lang=ts"
export * from "./SearchERP.vue?vue&type=script&lang=ts"
import style0 from "./SearchERP.vue?vue&type=style&index=0&id=1c12b381&prod&scoped=true&lang=css"
import style1 from "./SearchERP.vue?vue&type=style&index=1&id=1c12b381&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c12b381",
  null
  
)

export default component.exports